import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { withRoot } from "@nova/with-root"
const name = "color-finder-video"

export type ColorFinderSlice = {
    colorTimelineEnabled: boolean
    colorspaceEnabled: boolean
    imageActive: boolean
    listeningToKeyboardEvents: boolean
    colorFilterEnabled: boolean
}

const initialState: ColorFinderSlice = {
    colorTimelineEnabled: true,
    colorspaceEnabled: true,
    imageActive: false,
    listeningToKeyboardEvents: false,
    colorFilterEnabled: false,
}

const slice = createSlice({
    name,
    initialState: { ...initialState },
    reducers: {
        setColorTimelineEnabled: (state, { payload }: PayloadAction<boolean>) => {
            state.colorTimelineEnabled = payload
        },
        setColorspaceEnabled: (state, { payload }: PayloadAction<boolean>) => {
            state.colorspaceEnabled = payload
        },
        setColorFinderListeningToKeyboardEvents: (state, { payload }: PayloadAction<boolean>) => {
            state.listeningToKeyboardEvents = payload
        },
        setColorFilterEnabled: (state, { payload }: PayloadAction<boolean>) => {
            state.colorFilterEnabled = payload
        },
        resetColorFinderState: () => {
            return { ...initialState }
        },
    },
})

export const {
    setColorTimelineEnabled,
    setColorspaceEnabled,
    setColorFinderListeningToKeyboardEvents,
    setColorFilterEnabled,
    resetColorFinderState,
} = slice.actions

export const reducer = {
    [name]: slice.reducer,
}
export const {
    selectColorTimelineEnabled,
    selectColorspaceEnabled,
    selectColorFinderListeningToKeyboardEvents,
    selectColorFilterEnabled,
} = withRoot((r: Record<typeof name, ColorFinderSlice>) => r[name], {
    selectColorspaceEnabled: () => (s) => s.colorspaceEnabled,
    selectColorTimelineEnabled: () => (s) => s.colorTimelineEnabled,
    selectColorFinderListeningToKeyboardEvents: () => (s) => s.listeningToKeyboardEvents,
    selectColorFilterEnabled: () => (s) => s.colorFilterEnabled,
})
